export default __webpack_public_path__ + "static/media/avatar-8.5cbdb568.png";